<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>Admission Sign-ups</h3>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="total-header">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-12 a-h">
                    <!-- Select year of Application -->
                    <mat-label>
                      Application Year
                    </mat-label>
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-select class="mat-select-content" [(ngModel)]="year">
                        <mat-option *ngFor="let year of years" [value]="year.year" (click)="fetchSignupList(year.year)">
                          {{year.year}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <!-- Total Applications -->
                    <mat-label>Total Applications</mat-label>
                    <mat-form-field appearance="outline" color="primary" class="full-width">
                      <input matInput placeholder="Degree Applications" value="{{totalApplicants}}" readonly>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <!-- Total Degree Applications -->
                    <mat-label>Degree Applications</mat-label>
                    <mat-form-field appearance="outline" color="primary" class="full-width">
                      <input matInput placeholder="Degree Applications" value="{{totalDegreeApplicants}}" readonly>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <!-- Total Diploma Applications -->
                    <mat-label>Diploma Applications</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                      <input matInput placeholder="Diploma Applications" value="{{totalDiplomaApplicants}}" readonly>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-12">
                    <mat-label>Certificate Applications</mat-label>
                    <!-- Total Certificate Applications -->
                    <mat-form-field appearance="outline" class="full-width">
                      <input matInput placeholder="Certificate Applications" value="{{totalCertificateApplicants}}"
                        readonly>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 previewtext">
              <div class="row">
                <div class="col content-header">
                  <div>
                    <p>Preview data and comments of student sign-ups on our portal.</p>
                  </div>
                </div>
                <div class="excel-logo">
                  <a target="_self" rel="noopener noreferrer" class="ReportExport" (click)="downloadExcelFile()">
                    <img alt="Excel Logo" src="assets/img/excel.png">
                  </a>
                </div>
                <div class="excel-logo">
                  <a target="_self" rel="noopener noreferrer" class="ReportExport"
                    (click)="downloadCommentsExcelFile()">
                    <img alt="Comments Excel Logo" src="assets/img/comment-button.png">
                  </a>
                </div>
              </div>
            </div>
            <div class="col">
              <mat-divider></mat-divider>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 Application-Table">
              <mat-card>
                <mat-form-field>
                  <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                </mat-form-field>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="page-content">
                      <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 ">
                          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-striped" matSort
                            (matSortChange)="sortData($event)">
                            <!--- Note that these columns can be defined in any order.
                                      The actual rendered columns are set as a property on the row definition" -->
      
                            <!-- Applicant ID Column -->
                            <ng-container matColumnDef="No">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                              <td class="app-id" mat-cell *matCellDef="let element"><a
                                  (click)="addComment(element.sign_up_id)"> {{element.sign_up_id}}</a></td>
                            </ng-container>
      
                            <!-- Applicant Name -->
                            <ng-container matColumnDef="FullName">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Applicant</th>
                              <td mat-cell *matCellDef="let element"> {{element.first_name+' '+element.last_name}}</td>
                            </ng-container>
      
                            <!-- Gender -->
                            <ng-container matColumnDef="Gender">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Gender </th>
                              <td mat-cell *matCellDef="let element"> {{element.gender}} </td>
                            </ng-container>
      
                            <!-- Programme Type -->
                            <ng-container matColumnDef="ProgrammeTitle">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Programme
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.programme_type}} </td>
                            </ng-container>
      
                            <!-- Country -->
                            <ng-container matColumnDef="Nationality">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Country </th>
                              <td mat-cell *matCellDef="let element"> {{element.country_id}} </td>
                            </ng-container>
      
                            <!-- Mobile No -->
                            <ng-container matColumnDef="MobileNo">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Mobile No </th>
                              <td mat-cell *matCellDef="let element"> {{element.contact_no}} </td>
                            </ng-container>
      
                            <!-- EMail -->
                            <ng-container matColumnDef="Email">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                            </ng-container>
      
                            <ng-container matColumnDef="Password">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Password </th>
                              <td mat-cell *matCellDef="let element"> {{element.password}} </td>
                            </ng-container>
      
                            <!-- Advertising -->
                            <ng-container matColumnDef="Advert">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Advert </th>
                              <td mat-cell *matCellDef="let element"> {{element.advertising}} </td>
                            </ng-container>
      
                            <ng-container matColumnDef="Date">
                              <th class="theadSign" mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                              <td mat-cell *matCellDef="let element"> {{element.last_update}} </td>
                            </ng-container>
      
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                          <mat-paginator #paginator [length]="100" [pageSize]="25" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                            showFirstLastButtons>
                          </mat-paginator>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
